import * as React from 'react'
import * as styles from './BasicBadge.module.scss'
import * as cn from 'classnames'

interface BasicBadgeProps {
  children: React.ReactChild | React.ReactChild[]
  className: string
}

const BasicBadge = ({ children, className }: BasicBadgeProps) => (
  <div className={cn(styles.Badge, 'tst-badge', className)}>
    {children}
  </div>
)

export default BasicBadge
